"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashed = hashed;
exports.authenticated = void 0;

var _react = _interopRequireDefault(require("react"));

var _localToken = require("./local-token");

var _contextTypes = _interopRequireDefault(require("./context-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function hashed(o) {
  return Object.getOwnPropertyNames(o).map(function (prop) {
    return "".concat(prop, "=").concat(encodeURIComponent(o[prop]));
  }).join('&');
}

var authenticated = function authenticated() {
  return function (Component) {
    function authorize(provider, clientId) {
      var query = {
        client_id: clientId,
        response_type: 'token',
        redirect_uri: window.location
      };
      var url = "".concat(provider, "/authorize?").concat(hashed(query));
      window.location.replace(url);
    }

    var Authed =
    /*#__PURE__*/
    function (_React$Component) {
      _inherits(Authed, _React$Component);

      function Authed() {
        _classCallCheck(this, Authed);

        return _possibleConstructorReturn(this, _getPrototypeOf(Authed).apply(this, arguments));
      }

      _createClass(Authed, [{
        key: "render",
        value: function render() {
          var token = (0, _localToken.getLocalToken)();

          if (!token) {
            var _this$context = this.context,
                clientId = _this$context.clientId,
                provider = _this$context.provider,
                loggingInIndicator = _this$context.loggingInIndicator;
            authorize(provider, clientId);
            return loggingInIndicator || _react["default"].createElement("p", null, "Logging in...");
          } else {
            return _react["default"].createElement(Component, this.props);
          }
        }
      }]);

      return Authed;
    }(_react["default"].Component);

    Authed.contextTypes = _contextTypes["default"];
    return Authed;
  };
};

exports.authenticated = authenticated;
//# sourceMappingURL=authenticated.js.map